import { __module as r } from "./ghl-ui.es1608.js";
import { i as s } from "./ghl-ui.es1459.js";
import { _ as u } from "./ghl-ui.es1586.js";
import { r as n } from "./ghl-ui.es1552.js";
(function(a, t) {
  var o = s.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var i = o(u), f = o(n);
  function p(e) {
    return (0, f.default)(1, arguments), e instanceof Date || (0, i.default)(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
  }
  a.exports = t.default;
})(r, r.exports);
var c = r.exports;
export {
  c as i
};
